import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import {
    Label, Col
} from "reactstrap";


export default function CollapsableFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue } = formManager;//errors, control

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: data.hasOwnProperty("defaultValue") ? data.defaultValue : "" }).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if (data.defaultValue && data.functionManager?.performClick) {
            data.functionManager.performClick();
        }

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);


    var onClick = (e) => {
        var value = data.defaultValue;
        value = bindPropResult ? (getValues(bindPropResult) || data.defaultValue) : defaultVal;

        if (data.onActionEvents && data.onActionEvents["onClick"]) {
            data.onActionEvents["onClick"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: value }).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
    };

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.setValue = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            setValue(bindPropResult, value);
            if (withRerender) setShouldRender(!shouldRender);

            if (data.onActionEvents && data.onActionEvents["onChange"]) {
                data.onActionEvents["onChange"].forEach((args, index) => {
                    modelFctManager.onActionRequired(data.name, args, data, { value: value }).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }

            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.getValue = (src) => {
        return bindPropResult ? getValues(bindPropResult) : data.defaultValue;
    };
    data.functionManager.performClick = () => { onClick() };


    register(bindPropResult, {
        value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : ""),
        valueAsNumber: (data.subType === "integer" || data.subType === "float")
    });

    var frameClass = "d-inline-block mb-3";
    var frameStyle = {};
    var containerClass = "";

    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";

    var icon = "";
    var titleClass = "text-start ";
    var titleStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_collapsable");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            //titleClass += " w-100";
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            titleClass += modelFctManager.convertWidthToGrid(100);
        }
        if (design.size || design.width) frameStyle.width = (design.size ? (design.size + "px") : design.width);
        /*if (design.size || design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) frameStyle.width = design.width;
            //else {
            //    frameClass += " w-100";
            //}
        }*/
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) frameStyle.height = design.height;
            else {
                frameClass += " h-100";
            }
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        //Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));
        if (design.margin) frameClass = frameClass.replace("mb-3", "");
        if (design.marginBottom) frameClass = frameClass.replace("mb-3", "");
    }

    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_collapsableTitle", true);
    if (designTitle) {
        if (designTitle.alignment) {
            titleClass = titleClass.replace("text-start", "");
            var splitT = designTitle.alignment.split("|");
            splitT.forEach((part) => {
                titleClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleClass = titleClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
        if (designTitle.boxSize) {
            //titleWidthClass += " w-" + parseInt(parseFloat(designTitle.boxSize) * 100);
            titleClass = titleClass.replace(modelFctManager.convertWidthToGrid(100), "");
            titleClass += designTitle.boxSize === "auto" ? " col-auto" : modelFctManager.convertWidthToGrid(parseFloat(designTitle.boxSize) * 100);
        }

        Object.assign(titleStyle, modelFctManager.setCustomBackground(designTitle, data));
        //Object.assign(titleStyle, modelFctManager.managePadding(designTitle, titleClass));
        Object.assign(titleStyle, modelFctManager.manageMargin(designTitle, titleClass));
        if (designTitle.margin) titleClass = titleClass.replace("mb-0", "");
        if (designTitle.marginBottom) titleClass = titleClass.replace("mb-0", "");

        if (designTitle.fontColor) titleStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleStyle.fontStyle = "italic";
        }
    }
    var designIcon;
    if (getValues(bindPropResult) && data.customDesign?.extrasDesign?.altDesign_icon) {
        designIcon = data.customDesign?.extrasDesign?.altDesign_icon;
    }
    else {
        designIcon = data.customDesign?.designIcon;
    }
    designIcon = modelFctManager.prepareMergedDesign(data, designIcon, "default_collapsableIcon", true);

    if (designIcon) {
        var iconStyle = {};

        Object.assign(iconStyle, modelFctManager.setCustomBackground(designIcon, data));
        Object.assign(iconStyle, modelFctManager.managePadding(designIcon, ""));
        Object.assign(iconStyle, modelFctManager.manageMargin(designIcon, ""));


        if (designIcon.fontColor) iconStyle.color = modelFctManager.getRgbaFromHex(designIcon.fontColor);
        if (designIcon.fontSize) iconStyle.fontSize = designIcon.fontSize;
        if (designIcon.fontStyle) {
            if (designIcon.fontStyle.indexOf("bold") >= 0) iconStyle.fontWeight = "bold";
            if (designIcon.fontStyle.indexOf("italic") >= 0) iconStyle.fontStyle = "italic";
        }

        //TODO : alignment

        if (designIcon.icon) icon = <i className={`fa ${designIcon.icon.replace(/_/g, "-")}`} style={iconStyle} data-backimage={iconStyle.hasImage || null} data-imageopacity={iconStyle.alpha || null}></i>
    }
    var dividerStyle = {};
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_collapsableInput", true);
    if (designInput) {
        if (designInput.backColor) dividerStyle.color = modelFctManager.getRgbaFromHex(designInput.backColor);
        if (designInput.height) dividerStyle.borderTop = designInput.height + (data.subType === "divider-dashed" ? " dashed " : " solid ") + (designInput.backColor ? modelFctManager.getRgbaFromHex(designInput.backColor) : "");
    }


    if (!commonFunc.isBlank(titleClass)) containerClass += " row m-0 row-cols-lg-auto2 align-items-center";



    var defaultVal = data.defaultValue;
    defaultVal = bindPropResult ? (getValues(bindPropResult) || data.defaultValue) : defaultVal;
    var title = data.title;

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => { return modelFctManager.componentTyped(child, { ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) }); }) || "";

    var baseForm = "";
    if (commonFunc.isBlank(altT(title)) && (!data.subType || !data.subType.startsWith || !data.subType.startsWith("divider"))) {
        //frameClass = frameClass.replace("d-inline-block", "");
        baseForm = <div className={`${containerClass.replace("row", "")} ${formClass}`} onClick={onClick}>
            {icon}
            {childs}
        </div>;
    }
    else {
        baseForm = <div className={`${containerClass} ${formClass}`} onClick={onClick}>
            <div className={`${titleClass}`}>
                <Label className={`mb-0`} style={titleStyle} data-backimage={titleStyle.hasImage || null} data-imageopacity={titleStyle.alpha || null}>{altT(title)}</Label>
                {icon}
            </div>
            {data.subType === "divider" ? <hr className="hr-line-solid mb-0" style={dividerStyle} /> : ""}
            {data.subType === "divider-dashed" ? <hr className="hr-line-dashed mb-0" style={dividerStyle} /> : ""}
            {childs}
        </div>;
    }

    //console.debug("render collapsable");

    return <Col data-name="CollapsableFrag" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>{baseForm}</Col>;//align-self-center
}